import { requestPathname } from './routine-request-url';

/**
 * Detects Dappa API/endpoint authoring requests (EHQ-339):
 * `/project/{id}/v/{versionId}/api`, `.../api/{apiId}`,
 * `.../api/{apiId}/endpoints` and `.../api/{apiId}/endpoints/{endpointId}`.
 *
 * The Dappa dialogs and pages report validation failures (a duplicate name or
 * route, an empty slug) and 404s inline, next to what caused them, so the global
 * toast would be a second report of the same failure. Only 4xx other than 401
 * and 403 is suppressed: 401 must still start the login flow, and 403 carries
 * the "lock the project first" warning the user needs to act on.
 */
export function isDappaAuthoringRequest(url: string): boolean {
  return /\/project\/\d+\/v\/\d+\/api(\/\d+(\/endpoints(\/\d+)?)?)?$/.test(requestPathname(url));
}

/**
 * Whether a failed Dappa authoring request with this HTTP status is left for
 * the dialog or page to report. The error interceptor reports every other
 * status itself (401 login, 403 "lock the project" or access denied, 5xx and
 * network failures), so a caller that also reported those would show the same
 * failure twice.
 */
export function isDappaErrorReportedInline(status: number): boolean {
  return status >= 400 && status < 500 && status !== 401 && status !== 403;
}
